import { useEffect, useMemo, useState } from "react";
import apiClient from "../../../shared/API/apiClient";
import { useReportingYear } from "../../../context/ReportingYearContext";
import Toast from "../../../shared/components/Toast";
import { useLocation } from "react-router-dom";
const BRSRGeneralDisclosuresPage = () => {

const location=useLocation();

const passedEntityId=
  location.state?.legalEntityId || "";

const passedReportingYearId=
  location.state?.reportingYearId || "";

const passedReportingYear=
  location.state?.reportingYear || "";

const {reportingYear:contextReportingYear,reportingYearId:contextReportingYearId} = useReportingYear();

const reportingYear=passedReportingYear || contextReportingYear;

const reportingYearId=passedReportingYearId || contextReportingYearId;
const [isSubmitted, setIsSubmitted] = useState(false);
const [savingDraft, setSavingDraft] = useState(false);
const [selectedEntity,setSelectedEntity]=useState(passedEntityId);
const [saving, setSaving] = useState(false);
const [editingCell, setEditingCell] =useState(null);
//const [a1Data, setA1Data] = useState({});

const [submitting, setSubmitting] = useState(false);

  const [toast, setToast] = useState(null);

  const [legalEntities, setLegalEntities] = useState([]);

  
  const [dynamicSections, setDynamicSections] =useState([]);

  const [openAccordion, setOpenAccordion] =useState(["A1"]);

  const [organizationProfile, setOrganizationProfile] = useState({});

  const user =
    JSON.parse(
      localStorage.getItem("user")
    );

  const org_id = user?.org_id;

/*useEffect(() => {

  setA1Data({
    website:
      organizationProfile.website || "",

    contact_person_name:
      organizationProfile.contact_person_name || "",

    contact_person_email:
      organizationProfile.contact_person_email || "",

    contact_person_phone:
      organizationProfile.contact_person_phone || "",

    reporting_boundary: ""
  });

}, [organizationProfile]); */
  
  // =========================================
  // FETCH LEGAL ENTITIES
  // =========================================

  useEffect(() => {
    fetchLegalEntities();
  }, [reportingYearId]);

  const fetchLegalEntities =
    async () => {

      if (!reportingYearId) {
        return;
      }

      try {

        const res =
          await apiClient.get(
            "/api/legal-entities-by-year",
            {
              params: {
                reporting_year_id:
                  reportingYearId
              }
            }
          );

        if (
          res.data.code === 200
        ) {

          setLegalEntities(
            res.data.data || []
          );
        }

      } catch (error) {

        
      }
    };

  

  // =========================================
  // FETCH Entity PROFILE
  // =========================================

  /*useEffect(() => {
    fetchOrganizationProfile();
  }, [selectedEntity]);
*/
  

  // =========================================
  // FETCH SECTION A
  // =========================================

  useEffect(() => {
    fetchSectionA();
  }, [
    selectedEntity,
    reportingYearId
  ]);

  const fetchSectionA =
    async () => {

      if (
        !selectedEntity ||
        !reportingYearId
      ) {
        return;
      }

      try {

        setSavingDraft(true);

        const response =
          await apiClient.get(
            "/api/section-c",
            {
              params: {
                legal_entity_id:
                  selectedEntity,
                reporting_year_id:
                  reportingYearId
              }
            }
          );

        if (response.data.code === 200) {

          setIsSubmitted(response.data.is_submitted || false);

          const apiSections =
            response.data.data || [];

          setDynamicSections(apiSections);

          setOpenAccordion(
                apiSections.map((item) => item.id));
        }

      } catch (err) {

        console.log(err);

      } finally {

       setSavingDraft(false);
      }
    };

  
    const sections = dynamicSections;
  // =========================================
  // FIELD CHANGE
  // =========================================

  const handleFieldChange = (
    sectionId,
    questionId,
    value
  ) => {

    setDynamicSections((prev) =>
      prev.map((section) => {

        if (
          section.id !== sectionId
        ) {
          return section;
        }

        return {

          ...section,

          fields:
            section.fields.map(
              (field) => {

                if (
                  field.question_id ===
                  questionId
                ) {

                  return {
                    ...field,
                    value
                  };
                }

                return field;
              }
            )
        };
      })
    );
  };

  // =========================================
  // SAVE DRAFT
  // =========================================
const validateRequiredFields = () => {

  for (const section of sections) {

    for (const field of section.fields) {

      if (!field.is_required) {
        continue;
      }

      const value = field.value;

      if (
        value === null ||
        value === undefined ||
        String(value).trim() === ""
      ) {

        setToast({
          type: "error",
          message: `${field.label} is required`
        });

        return false;
      }
      if (
  field.key === "contact_person_email"
) {

  const emailRegex =
    /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

  if (
    !emailRegex.test(
      String(value).trim()
    )
  ) {

    setToast({
      type: "error",
      message:
        "Please enter a valid Contact Person Email"
    });

    return false;
  }
}

if (
  field.key === "contact_person_phone"
) {

  const phone =
    String(value)
      .replace(/\s+/g, "")
      .replace(/-/g, "");

  if (
    !/^(\+?\d{10,15})$/.test(phone)
  ) {

    setToast({
      type: "error",
      message:
        "Please enter a valid Contact Person Phone Number"
    });

    return false;
  }
}

if (
  field.key === "website"
) {

  try {

    new URL(
      String(value).trim()
    );

  } catch {

    setToast({
      type: "error",
      message:
        "Please enter a valid Website URL (e.g. https://company.com)"
    });

    return false;
  }
}
    }
  }

  return true;
};

const handleSaveDraft =
  async (e) => {

    e?.preventDefault?.();
    e?.stopPropagation?.();

    if (savingDraft) {
      return;
    }

    try {

      setSavingDraft(true);

      const payloads =
        dynamicSections.map(
          (section) => ({

            legal_entity_id:
              selectedEntity,

            reporting_year_id:
              reportingYearId,

            section_id:
              section.id,

            answers:
              section.fields
                ?.filter(
                  (field) =>
                    !field.is_auto
                )
                ?.map(
                  (field) => ({

                    question_id:
                      field.question_id,

                    value:
                      field.value || ""
                  })
                ) || []
          })
        );

      await Promise.all(

        payloads
          .filter(
            (payload) =>
              payload.answers.length > 0
          )
          .map(
            (payload) =>
              apiClient.post(
                "/api/section-c/save",
                payload
              )
          )
      );

      setToast({
        type: "success",
        message:
          "Section C saved successfully"
      });

      await fetchSectionA();

    } catch (err) {

      console.log(err);

      setToast({
        type: "error",
        message:
          err?.response?.data?.message ||
          "Failed to save Section C"
      });

    } finally {

      setSavingDraft(false);
    }
  };

  // =========================================
  // SUBMIT
  // =========================================

const handleSubmit=async(e)=>{
  e?.preventDefault?.();
  e?.stopPropagation?.();
  if(!validateRequiredFields()) return;

  try{
    setSubmitting(true);

    const payloads=dynamicSections.map(section=>({
      legal_entity_id:selectedEntity,
      reporting_year_id:reportingYearId,
      section_id:section.id,
      answers:section.fields?.filter(field=>!field.is_auto)?.map(field=>({
        question_id:field.question_id,
        value:field.value||""
      }))||[]
    }));

    await Promise.all(
      payloads
        .filter(payload=>payload.answers.length)
        .map(payload=>apiClient.post("/api/section-c/save",payload))
    );

    const response=await apiClient.post("/api/section-c/submit",{
      legal_entity_id:selectedEntity,
      reporting_year_id:reportingYearId
    });

    setToast({
      type:"success",
      message:response.data.message||"Section C submitted successfully"
    });

    await fetchSectionA();
  }catch(err){
    console.log(err);
    setToast({
      type:"error",
      message:err?.response?.data?.message||"Failed to submit Section C"
    });
  }finally{
    setSubmitting(false);
  }
};
  // =========================================
  // OVERALL STATS
  // =========================================

  const totalRequired =
    sections.reduce(
      (acc, item) =>
        acc + item.total,
      0
    );

  const totalCompleted =
    sections.reduce(
      (acc, item) =>
        acc + item.completed,
      0
    );

  const overallPercentage =
    totalRequired > 0
      ? Math.round(
          (
            totalCompleted /
            totalRequired
          ) * 100
        )
      : 0;

 const getAutoLabel = (field) => {
  if (!field.is_auto) return null;

  if (
    field.question_code?.startsWith("A1_")
  ) {
    return "Synced from Legal Entity Profile";
  }

  if (field.source_key?.startsWith("P")) {
    const principle =
      field.source_key.split("-")[0];

    return `Synced from ${principle}`;
  }

  return "Auto Populated";
};

const editablePopupColumns = [
  "grievance_link",
  "current_year_remarks",
  "previous_year_remarks",
  "rationale",
  "mitigation_approach",
  "financial_implications"
];
const popupLabels = {
  rationale:
    "Rationale for Identifying Risk / Opportunity",

  mitigation_approach:
    "Approach to Adapt or Mitigate",

  financial_implications:
    "Financial Implications",

  grievance_link:
    "Policy / Web Link",

  current_year_remarks:
    "Current FY Remarks",

  previous_year_remarks:
    "Previous FY Remarks"
};
const grievanceQuestionCodes = [
  "A7_COMPLAINTS_GRIEVANCES"
];
  // =========================================
  // FIELD RENDER
  // =========================================

const renderField = (
  section,
  field,
  index
) => {

  const isDisabled = isSubmitted || field.is_auto;
  const isWorkforceSummary = field.source_key === "workforce_summary_table";

 const commonProps = {

          value: field.value || "",

          placeholder:field.placeholder || "",

          disabled: isDisabled,

          onChange: (e) => {

          handleFieldChange(
            section.id,
            field.question_id,
            e.target.value
          );

            }
};
console.log("isSubmitted", isSubmitted);
  return (

    <div
  key={index}
  className={`dynamic-field ${
    section.id !== "A1" &&
    (
      field.field_type === "textarea" ||
      field.field_type === "dynamic_table"
    )
      ? "full-width"
      : ""
  }`}
>

      <label>
        {field.label}
        {field.is_required && " *"}
      </label>
      {field.question_code === "A7_Q2" && (
      <div className="brsr-section-subtitle">
        Please indicate material responsible business conduct and sustainability issues pertaining to
environmental and social matters that present a risk or an opportunity to your business,
rationale for identifying the same, approach to adapt or mitigate the risk along-with its
financial implications, as per the following format
      </div>
      )}

                          {/* ===================================== */}
                          {/* TEXTAREA */}
                          {/* ===================================== */}

                          {field.field_type === "textarea" ? (

                            <textarea {...commonProps} />

                          ) : field.field_type === "select" ? (

                            <select {...commonProps}>

                              <option value="">
                                Select
                              </option>

                              {Array.isArray(field.options) &&
                                field.options.map((opt, i) => (

                                  <option
                                    key={i}
                                    value={opt.value}
                                  >
                                    {opt.label}
                                  </option>

                                ))}

                            </select>

                          ) : field.field_type === "dynamic_table" ? (

                            <div className="complaints-table-wrap">

                              <table className="complaints-table">

                                <thead>

                                  <tr>

                            <th>S. No.</th>

                            {(field.ui_schema?.columns || []).map(
                              (column) => (
                                <th key={column.key}>
                                  {column.label}
                                </th>
                              )
                            )}

                            {field.ui_schema?.allow_delete_row && (
                              <th>Action</th>
                            )}

                          </tr>

                                </thead>

      <tbody>

        {
  (
    Array.isArray(field.value) &&
    field.value.length > 0

      ? field.value

      : (
          field.ui_schema?.default_rows?.length > 0

            ? field.ui_schema.default_rows

            : field.ui_schema?.allow_add_row
  ? [{}]
  : Array.from(
      {
        length:
          field.ui_schema?.rows || 3
      },
      () => ({})
    )
        )

  ).map((row, rowIndex) => (

          <tr key={rowIndex}>

            <td>
              {rowIndex + 1}
            </td>

            {(field.ui_schema?.columns || []).map(

              (column) => (

                <td key={column.key}>

              {
                isWorkforceSummary || column.type === "readonly" ? (

                    <span className="workforce-cell-text">
                      {row?.[column.key] || 0}
                    </span>

                  ) : column.type === "select" ? (

                      <select
                        value={row?.[column.key] || ""}
                        disabled={isSubmitted || field.is_auto}
                        onChange={(e) => {

                          let rows =
                                    Array.isArray(field.value) &&
                                    field.value.length > 0
                                      ? [...field.value]
                                      : (
                                          field.ui_schema?.default_rows?.length > 0
                                            ? field.ui_schema.default_rows.map(
                                                row => ({ ...row })
                                              )
                                            : []
                                        );

                          rows[rowIndex] = {
                            ...rows[rowIndex],
                            [column.key]: e.target.value
                          };

                          handleFieldChange(
                            section.id,
                            field.question_id,
                            rows
                          );
                        }}
                      >
                        <option value="">
                          Select
                        </option>

                        {(column.options || []).map(
                          (option, idx) => (
                            <option
                              key={idx}
                              value={option}
                            >
                              {option}
                            </option>
                          )
                        )}
                      </select>

                    ) : (
            editablePopupColumns.includes(column.key) ? (

                                    isSubmitted ? (

                                      row?.[column.key] &&
                                      String(row[column.key]).trim() !== ""

                                        ? (
                                            <button
                                              type="button"
                                              className="ecf-edit-btn"
                                              onClick={() => {

                                                setEditingCell({
                                                  sectionId: section.id,
                                                  questionId: field.question_id,
                                                  rowIndex,
                                                  columnKey: column.key,
                                                  value: row?.[column.key] || "",
                                                  rowLabel:
                                                    row?.stakeholder_group ||
                                                    row?.particular ||
                                                    `Row ${rowIndex + 1}`
                                                });

                                              }}
                                            >
                                              <span className="reason-badge saved">
                                                {column.key === "grievance_link"
                                                  ? "🔗"
                                                  : "✓"}
                                              </span>
                                            </button>
                                          )

                                        : (
                                            <span className="text-muted">
                                              N/A
                                            </span>
                                          )

                                    ) : (

                                      <button
                                        type="button"
                                        className="ecf-edit-btn"
                                        disabled={
                                          column.key === "grievance_link" &&
                                          row?.grievance_mechanism !== "Yes"
                                        }
                                        onClick={() => {

                                          if (
                                            column.key === "grievance_link" &&
                                            row?.grievance_mechanism !== "Yes"
                                          ) {
                                            return;
                                          }

                                          setEditingCell({
                                            sectionId: section.id,
                                            questionId: field.question_id,
                                            rowIndex,
                                            columnKey: column.key,
                                            value: row?.[column.key] || "",
                                            rowLabel:
                                              row?.stakeholder_group ||
                                              row?.particular ||
                                              `Row ${rowIndex + 1}`
                                          });

                                        }}
                                      >
                                        <span
                                          className={
                                            row?.[column.key]
                                              ? "reason-badge saved"
                                              : "reason-badge add"
                                          }
                                        >
                                          {column.key === "grievance_link"
                                            ? "🔗"
                                            : (
                                                row?.[column.key]
                                                  ? "✓"
                                                  : "✏️"
                                              )}
                                        </span>
                                      </button>

                                    )

                              ) : (

                            <input type={column.type || "text"} value={row?.[column.key] || ""} disabled={ isSubmitted ||
                          field.is_auto ||
                          column.type === "readonly"
                              }

                              onChange={(e) => {

                                let rows =
                                      Array.isArray(field.value) &&
                                      field.value.length > 0

                                        ? [...field.value]

                                        : (
                                            field.ui_schema?.default_rows
                                              ? [...field.ui_schema.default_rows]
                                              : []
                                          );

                                if (!field.ui_schema?.allow_add_row) {

                                      while (
                                        rows.length <
                                        (field.ui_schema?.rows || 3)
                                      ) {
                                        rows.push({});
                                      }

                                    }

                      const updatedRow = {

                            ...rows[rowIndex],
                            [column.key]: e.target.value
                          };

                          if (field.question_code === "A4_DIFFERENTLY_ABLED_WORKFORCE_TABLE") {

                                const total = Number(updatedRow.total || 0);
                                const male = Number(updatedRow.male || 0);
                                const female = Number(updatedRow.female || 0);

                                if (male > total) {
                                  setToast({
                                    type: "error",
                                    message: "Male count cannot exceed Total"
                                  });
                                  return;
                                }

                                if (female > total) {
                                  setToast({
                                    type: "error",
                                    message: "Female count cannot exceed Total"
                                  });
                                  return;
                                }

                                if ((male + female) > total) {
                                  setToast({
                                    type: "error",
                                    message: "Male + Female count cannot exceed Total"
                                  });
                                  return;
                                }

                                  updatedRow.male_percentage = total > 0
                                    ? Number(((male / total) * 100).toFixed(2))
                                    : 0;

                                  updatedRow.female_percentage = total > 0
                                    ? Number(((female / total) * 100).toFixed(2))
                                    : 0;

                                  rows[rowIndex] = updatedRow;

                                  if (rows.length >= 3) {

                                    rows[2] = {
                                      particular: "Total Differently Abled Employees (D + E)",
                                      total: Number(rows[0]?.total || 0) + Number(rows[1]?.total || 0),
                                      male: Number(rows[0]?.male || 0) + Number(rows[1]?.male || 0),
                                      female: Number(rows[0]?.female || 0) + Number(rows[1]?.female || 0)
                                    };

                                    rows[2].male_percentage = rows[2].total > 0
                                      ? Number(((rows[2].male / rows[2].total) * 100).toFixed(2))
                                      : 0;

                                    rows[2].female_percentage = rows[2].total > 0
                                      ? Number(((rows[2].female / rows[2].total) * 100).toFixed(2))
                                      : 0;
                                  }

                                  if (rows.length >= 6) {

                                    rows[5] = {
                                      particular: "Total Differently Abled Workers (F + G)",
                                      total: Number(rows[3]?.total || 0) + Number(rows[4]?.total || 0),
                                      male: Number(rows[3]?.male || 0) + Number(rows[4]?.male || 0),
                                      female: Number(rows[3]?.female || 0) + Number(rows[4]?.female || 0)
                                    };

                                    rows[5].male_percentage = rows[5].total > 0
                                      ? Number(((rows[5].male / rows[5].total) * 100).toFixed(2))
                                      : 0;

                                    rows[5].female_percentage = rows[5].total > 0
                                      ? Number(((rows[5].female / rows[5].total) * 100).toFixed(2))
                                      : 0;
                                  }
                              }

                          if (field.question_code === "A4_WOMEN_REPRESENTATION") {

                            const total = Number(updatedRow.total || 0);
                            const female = Number(updatedRow.female || 0);

                            if (female > total) {
                              setToast({
                                type: "error",
                                message: "Female count cannot exceed Total"
                              });
                              return;
                            }

                            updatedRow.female_percentage = total > 0
                              ? Number(((female / total) * 100).toFixed(2))
                              : 0;

                              rows[rowIndex] = updatedRow;
                          }

                          if (
                            updatedRow.plants !== undefined ||
                            updatedRow.offices !== undefined
                          ) {

                            const plants =
                              Number(updatedRow.plants || 0);

                            const offices =
                              Number(updatedRow.offices || 0);

                            updatedRow.total =
                              plants + offices;
                          }

                      rows[rowIndex] = updatedRow;

                      handleFieldChange(
                        section.id,
                        field.question_id,
                        rows
                      );

                    }}
                  />
                    )
                  )}
                </td>

              )
            )}
            {field.ui_schema?.allow_delete_row && (
                      <td className="action-cell">
                      {!isSubmitted ? (

  <button
    type="button"
    className="ecf-remove-btn"
    title="Remove Row"
    onClick={() => {

      const rows =
        Array.isArray(field.value)
          ? [...field.value]
          : [];

      rows.splice(rowIndex, 1);

      handleFieldChange(
        section.id,
        field.question_id,
        rows
      );

    }}
  >
    ✕
  </button>

) : (

  "N/A"

)}
                      </td>
                    )}
          </tr>

        ))}

      </tbody>

    </table>

                  {field.ui_schema?.allow_add_row &&
                   !isSubmitted &&
                   !field.is_auto && (

                    <div style={{ marginTop: "10px" }}>
                      <button
                        type="button"
                        className="org-btn-save"
                        onClick={() => {

                          const rows =
                            Array.isArray(field.value)
                              ? [...field.value]
                              : [];

                          rows.push({});

                          handleFieldChange(
                            section.id,
                            field.question_id,
                            rows
                          );
                        }}
                      >
                        + Add Row
                      </button>
                    </div>

                  )}

                  </div>

                  ) : (

                            <input
                              type={
                                field.field_type ||
                                "text"
                              }
                              {...commonProps}
                            />

                              )}
                  {field.is_auto && (
                    <div className="field-auto-wrap">
                    <span className="status auto-badge">✨{getAutoLabel(field)}</span>
                     
                    </div>
                  )}

                  </div>
                    );
                  };

      return (

    <div className="dash-page">

      {/* HEADER */}

      <div className="dash-page-title">
        Section C — PRINCIPLE WISE PERFORMANCE DISCLOSURE
      </div>

      <div className="dash-page-subtitle">
        This section is aimed at helping entities demonstrate their performance in integrating the
Principles and Core Elements with key processes and decisions. The information sought is
categorized as “Essential” and “Leadership”. While the essential indicators are expected to be
disclosed by every entity that is mandated to file this report, the leadership indicators may be
voluntarily disclosed by entities which aspire to progress to a higher level in their quest to be
socially, environmentally and ethically responsible.
      </div>

      {/* FILTER */}

      <div className="filter-card">

        <div className="filter-group">

          <label>
            Reporting Year *
          </label>

          <input
            className="filter-input"
            value={
              reportingYear || ""
            }
            disabled
          />

        </div>

        <div className="filter-group">

          <label>
            Legal Entity *
          </label>

          <select className="filter-input" value={selectedEntity} onChange={(e) => setSelectedEntity(e.target.value)}>
                <option value="">Select</option>

                {legalEntities.map((entity) => (
                  <option
                    key={entity.entity_id}
                    value={entity.entity_id}
                  >
                    {entity.entity_name}
                  </option>
                ))}
          </select>

        </div>

      </div>
      {!selectedEntity && (
  <div className="st-empty-entity">
    <div className="st-empty-entity__icon">
      <i className="fa-solid fa-building" />
    </div>

    <div className="st-empty-entity__title">
      Select a Legal Entity to continue
    </div>

    <div className="st-empty-entity__sub">
      Select a legal entity above to track Section C disclosure progress and take required actions.
    </div>
  </div>
)}
      {selectedEntity && (
        <>
        
{isSubmitted && (

  <div class="bms-info-bar">
  <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-eye" aria-hidden="true">
  <path d="M2.062 12.348a1 1 0 0 1 0-.696 10.75 10.75 0 0 1 19.876 0 1 1 0 0 1 0 .696 10.75 10.75 0 0 1-19.876 0"></path><circle cx="12" cy="12" r="3"></circle></svg>
  <span>
  <strong>Section C has been submitted and is now read-only.</strong></span></div>
)}
{!isSubmitted && (
<div
            className="draft-box"
            
          >
            ✏️ Draft — Editable
          </div>
          )}
      {/* OVERALL */}

      <div className="brsr-sticky-wrapper">

        <div className="brsr-overall-card">

          <div className="brsr-overall-left">

            <div className="brsr-overall-label">
              OVERALL COMPLETION
            </div>

            <div className="brsr-overall-text">

              {totalCompleted}
              {" "}of{" "}
              {totalRequired}
              {" "}required fields completed

            </div>

          </div>

          <div className="brsr-progress-area">

            <div className="brsr-progress-track">

              <div
                className="brsr-progress-fill"
                style={{
                  width:
                    `${overallPercentage}%`
                }}
              />

            </div>

            <div className="brsr-progress-percent">
              {overallPercentage}%
            </div>

          </div>

        </div>

      </div>

      {/* SECTIONS */}

      <div className="brsr-sections-wrapper">

        {Array.isArray(sections) &&
          sections.map(
            (section) => {

              const isOpen =
                openAccordion.includes(
                  section.id
                );

              return (

                <div
                  className="brsr-section-card"
                  key={section.id}
                >

                  <div
                    className="brsr-section-header"
                    onClick={() => {

                      if (isOpen) {

                        setOpenAccordion(
                          openAccordion.filter(
                            (id) =>
                              id !==
                              section.id
                          )
                        );

                      } else {

                        setOpenAccordion([
                          ...openAccordion,
                          section.id
                        ]);
                      }
                    }}
                  >

                    <div className="brsr-section-left">

                      <div
                        className={`accordion-arrow ${
                          isOpen
                            ? "open"
                            : ""
                        }`}
                      >
                        ›
                      </div>

                      <div>

                        <div className="brsr-section-title-row">

                          <span className="section-id">
                            {section.id}
                          </span>

                          <span className="section-title-A">
                            {section.title}
                          </span>

                          <span
                            className={`status-badge ${section.status
                              .toLowerCase()
                              .replaceAll(
                                " ",
                                "-"
                              )}`}
                          >

                            {section.status ===
                            "Complete"
                              ? "✓ Complete"
                              : section.status ===
                                "Not Started"
                              ? "Not started"
                              : `${section.percentage}% · ${section.completed}/${section.total}`}

                          </span>

                        </div>

                        <div className="brsr-section-subtitle">
                          {section.subtitle}
                        </div>

                      </div>

                    </div>

                    <div className="brsr-right-progress">

                      <div className="mini-progress">

                        <div
                          className="mini-progress-fill"
                          style={{
                            width:
                              `${section.percentage}%`
                          }}
                        />

                      </div>

                      <span>
                        {section.percentage}%
                      </span>

                    </div>

                  </div>

                  {isOpen && (

                    <div className="brsr-section-body">

                      <div className="dynamic-form-grid">

                        {section.fields.map(
                          (
                            field,
                            index
                          ) =>
                            renderField(
                              section,
                              field,
                              index
                            )
                        )}

                      </div>

                    </div>

                  )}

                </div>

              );
            }
          )}

        

      </div>
      {!isSubmitted && (
            <div className="ecf-footer" onClick={(e) => { e.preventDefault(); e.stopPropagation(); }}>

                    <button type="button" className="org-btn-cancel" onClick={handleSaveDraft} disabled={savingDraft}>{savingDraft?"Saving...":"Save Draft"}</button>

                  <button type="button" className="org-btn-save" onClick={handleSubmit} disabled={submitting}>{submitting?"Submitting...":"Submit Section"}</button>
        </div>
        )}
      {/* TOAST */}

      {toast && (

        <Toast
          message={
            toast.message
          }
          type={
            toast.type
          }
          onClose={() =>
            setToast(null)
          }
        />

      )}
        {editingCell && (

          <div className="reason-modal-overlay">

            <div className="reason-modal">
        <div className="reason-editor-header">
          {editingCell.rowLabel}
          {" - "}
          {popupLabels[editingCell.columnKey]}
        </div>

              {editingCell.columnKey ===
              "grievance_link" ? (

                <input
                  type="url"
                  className="form-control"
                  placeholder="Enter grievance policy URL (e.g. https://company.com/grievance-policy)"
                  value={editingCell.value} disabled={isSubmitted}
                  onChange={(e) =>
                    setEditingCell({
                      ...editingCell,
                      value: e.target.value
                    })
                  }
                />

              ) : (

                <textarea disabled={isSubmitted}
                  rows={6}
                  className="form-control"
                  placeholder={editingCell.rowLabel
              ? `Enter remarks for ${editingCell.rowLabel}`
              : "Enter remarks"
          }
                  value={editingCell.value}
                  onChange={(e) =>
                    setEditingCell({
                      ...editingCell,
                      value: e.target.value
                    })
                  }
                />

              )}

              <div
                style={{
                  display: "flex",
                  justifyContent: "flex-end",
                  gap: "10px",
                  marginTop: "15px"
                }}
              >

                <button
                  type="button"
                  className="org-btn-cancel"
                  onClick={() =>
                    setEditingCell(null)
                  }
                >
                  Cancel
                </button>
        {!isSubmitted &&
                           (
               <button type="button" className="org-btn-save" onClick={() => {

          const value = editingCell.value?.trim();

          if (!value) {
            setToast({
              type: "error",
              message: editingCell.columnKey === "grievance_link"
                ? "Policy / Web Link is required"
                : "Remarks cannot be blank"
            });
            return;
          }

          if (editingCell.columnKey === "grievance_link") {
            try {
              new URL(value);
            } catch {
              setToast({
                type: "error",
                message: "Please enter a valid URL (e.g. https://example.com)"
              });
              return;
            }
          }

          const field = dynamicSections
            .find(s => s.id === editingCell.sectionId)
            ?.fields?.find(
              f => f.question_id === editingCell.questionId
            );

          if (!field) return;

          const rows = field.value?.length
            ? [...field.value]
            : (
                field.ui_schema?.default_rows?.map(
                  row => ({ ...row })
                ) || []
              );

          rows[editingCell.rowIndex] = {
            ...rows[editingCell.rowIndex],
            [editingCell.columnKey]: value
          };

          handleFieldChange(
            editingCell.sectionId,
            editingCell.questionId,
            rows
          );

          setEditingCell(null);

        }}>
          Save
        </button>
        )}
              </div>

            </div>

          </div>

        )}
        </>
 )}
    </div>


  );
};

export default BRSRGeneralDisclosuresPage;